import { lighten, darken } from 'polished'

import image from './textures/texture-otis-redding.png'

const title = `#442d6b`
const theme_color = `${lighten(0.6, title)}`
const background = `#FEFEFE`
const dark_background = `#202228`
const dark_theme_color = `#FEFEFE`

const margin_zero = `0em`

const padding_zero = `0em`
const padding_small = `9px`
const padding_med = `16px`
const margin_med = `16px`
const margin_lg = `24px`
const padding_lg = `24px`
const transition_time = `.5s`

const font_size = `16px`
const texture = `url(${image})`

const mobile = `(max-width : 480px)`
const tablet = `(min-width : 481px) and (max-width : 1039px)`
const desktop = `(min-width : 1040px)`

const frontend_next = `#FE822B`

const box_shadow = `0 3px 8px 0 rgba(0,0,0,0.2), 0 0 0 1px rgba(0,0,0,0.08)`
const stripe = `rgb(210,230,240)`
const stripe_dark = darken(0.05, stripe)

const border_radius = '4.2px'

export const theme = {
  title,
  background,
  'margin-zero': margin_zero,
  'margin-med': margin_med,
  'margin-lg': margin_lg,
  'padding-med': padding_med,
  'padding-lg': padding_lg,
  'padding-small': padding_small,
  'padding-zero': padding_zero,
  'transition-time': transition_time,
  'font-size': font_size,
  'theme-color': theme_color,
  texture,
  mobile,
  tablet,
  desktop,
  'dark-background': dark_background,
  'dark-theme-color': dark_theme_color,
  'box-shadow': box_shadow,
  stripe,
  'stripe-dark': stripe_dark,
  'border-radius': border_radius,
  course: {
    'frontend-serverless': frontend_next,
    'end-to-end-react': `#8E70B2`,
  },
  colors: {
    'language-typescript': '#2b7489',
    'language-tsx': '#2b7489',
    'language-javascript': '#efbb35',
    'language-js': '#efbb35',
    'language-css': '#563d7c',
    'language-html': '#e34c26',
  },
}
